import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 9, viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.77666 8.01562C2.77666 8.22305 2.94306 8.39062 3.14931 8.39062H6.22431C6.43056 8.39062 6.59697 8.22305 6.59697 8.01562V5.71875H2.77666V8.01562ZM9.00049 0H0.373142C0.086033 0 -0.0932638 0.312891 0.0508768 0.5625L2.64424 4.96875H6.73174L9.3251 0.5625C9.46689 0.312891 9.2876 0 9.00049 0Z", fill: "black", fillOpacity: 0.25 }));
const ForwardRef = forwardRef(SvgFilterIcon);
export default ForwardRef;
